import {combineReducers} from 'redux'
import {createPivotTableReducer} from 'reducers/pivotTable'
import types from 'actions/types'
import {get} from 'lodash'

export const deliveriesPivotTableKey = 'deliveriesContext.deliveries.deliveries'
export const deliveryItemsPivotTableKey = 'deliveriesContext.deliveries.items'
export const deliveryDocumentsPivotTableKey = 'deliveriesContext.deliveries.documents'
export const deliveryOperationsPivotTableKey = 'deliveriesContext.deliveries.operations'
export const deliveryActualTimesPivotTableKey = 'deliveriesContext.deliveries.actualTimes'

export const deliveryTypes = (state = [], action) => {
    switch (action.type) {
        case types.DELIVERIES_DELIVERIES_UPDATE_FILTERS:
            return get(action, 'filters.deliveryTypes', state)
        default:
            return state
    }
}

export const workCentreId = (state = [], action) => {
    switch (action.type) {
        case types.DELIVERIES_DELIVERIES_UPDATE_FILTERS:
            return get(action, 'filters.workCentreId', state)
        default:
            return state
    }
}

export const deliveryStatus = (state = [], action) => {
    switch (action.type) {
        case types.DELIVERIES_DELIVERIES_UPDATE_FILTERS:
            return get(action, 'filters.deliveryStatus', state)
        default:
            return state
    }
}

export const userTypes = (state = [], action) => {
    switch (action.type) {
        case types.DELIVERIES_DELIVERIES_UPDATE_FILTERS:
            return get(action, 'filters.userTypes', state)
        default:
            return state
    }
}

export const contacts = (state = [], action) => {
    switch (action.type) {
        case types.DELIVERIES_DELIVERIES_UPDATE_FILTERS:
            return get(action, 'filters.contacts', state)
        default:
            return state
    }
}

export const orderTypeId = (state = [], action) => {
    switch (action.type) {
        case types.DELIVERIES_DELIVERIES_UPDATE_FILTERS:
            return get(action, 'filters.orderTypeId', state)
        default:
            return state
    }
}

export const dateTypes = (state = [], action) => {
    switch (action.type) {
        case types.DELIVERIES_DELIVERIES_UPDATE_FILTERS:
            return get(action, 'filters.dateTypes', state)
        default:
            return state
    }
}

export const timeKey = (state = null, action) => {
    switch (action.type) {
        case types.DELIVERIES_DELIVERIES_UPDATE_FILTERS:
            return get(action, 'filters.timeKey', state)
        default:
            return state
    }
}

export const targetStart = (state = null, action) => {
    switch (action.type) {
        case types.DELIVERIES_DELIVERIES_UPDATE_FILTERS:
            return get(action, 'filters.targetStart', state)
        default:
            return state
    }
}

export const targetEnd = (state = null, action) => {
    switch (action.type) {
        case types.DELIVERIES_DELIVERIES_UPDATE_FILTERS:
            return get(action, 'filters.targetEnd', state)
        default:
            return state
    }
}

export const deliveryDepartments = (state = [], action) => {
    switch (action.type) {
        case types.DELIVERIES_DEPARTMENTS_LOAD_SUCCESS:
            return get(action, 'data', [])

        default:
            return state
    }
}

export const deliveryWorkCentres = (state = [], action) => {
    switch (action.type) {
        case types.DELIVERIES_WORK_CENTRES_LOAD_SUCCESS:
            const data = get(action, 'data', [])
            return data.map(workCentre => {
                const deliveriesSummary = get(workCentre, 'deliveriesSummary', {})
                const count = get(deliveriesSummary, 'count', 0)
                return {
                    hasDeliveries: count > 0,
                    deliveryCount: count,
                    ...workCentre,
                }
            })

        default:
            return state
    }
}

export const deliveryWorkCentresLoaded = (state = false, action) => {
    switch (action.type) {
        case types.DELIVERIES_WORK_CENTRES_LOAD_SUCCESS:
        case types.DELIVERIES_WORK_CENTRES_LOAD_FAILURE:
            return true
        default:
            return state
    }
}

export const calendarData = (state = [], action) => {
    switch (action.type) {
        case types.DELIVERIES_LOAD_DELIVERIES_SUCCESS:
            return get(action, 'data', [])

        case types.DELIVERIES_MOVE_DELIVERY_ATTEMPT:
            return state
                .filter(delivery => delivery.id !== action.updatedDelivery.id)
                .concat([action.updatedDelivery])

        default:
            return state
    }
}

export const calendarSelectedDate = (state = new Date(), action) => {
    switch (action.type) {
        case types.DELIVERIES_UPDATE_CALENDAR_SELECTED_DATE:
            return action.date

        default:
            return state
    }
}

export const calendarViewRange = (state = 'month:0', action) => {
    switch (action.type) {
        case types.DELIVERIES_UPDATE_CALENDAR_VIEW_RANGE:
            return (action.viewRange)

        default:
            return state
    }
}

export const calendarFieldOrder = (state = null, action) => {
    switch (action.type) {
        case types.DELIVERIES_UPDATE_CALENDAR_FIELD_ORDER:
            return action.order
        default:
            return state
    }
}

export const calendarSelectedFields = (state = null, action) => {
    switch (action.type) {
        case types.DELIVERIES_UPDATE_CALENDAR_SELECTED_FIELDS:
            return action.fields
        default:
            return state
    }
}

export const filters = (state = {}, action) => {
    if (Array.isArray(state)) state = {}
    switch (action.type) {
        case types.DELIVERIES_UPDATE_DELIVERY_FILTERS:
            return action.deliveryFilters
        default:
            return state
    }
}

export const selectedDepartment = (state = null, action) => {
    switch (action.type) {
        case types.DELIVERIES_SELECT_DELIVERY_DEPARTMENT:
            return action.id
        default:
            return state
    }
}

export const isLoadingItems = (state = false, action) => {
    switch (action.type) {
        case types.DELIVERIES_DELIVERY_DIALOG_INITIALISE_ATTEMPT:
            return true
        case types.DELIVERIES_DELIVERY_DIALOG_INITIALISE_SUCCESS:
            return false
        default:
            return state
    }
}

export const deliveryCounts = (state = null, action) => {
    switch (action.type) {
        case types.DELIVERIES_LOAD_DELIVERY_COUNTS_SUCCESS:
            return action.data
        default:
            return state
    }
}

export const deliveryDialogCurrentTab = (state = 'Items', action) => {
    switch (action.type) {
        case types.DELIVERIES_DELIVERY_DIALOG_CHANGE_TAB:
            return action.tab
        case types.DELIVERIES_HIDE_DELIVERY_DIALOG:
            return 'Items'
        default:
            return state
    }
}

export const isShowingOperationsValidityWarning = (state = false, action) => {
    switch (action.type) {
        case types.DELIVERIES_DELIVERY_DIALOG_HIDE_OPERATIONS_VALIDITY_WARNING:
            return false
        case types.DELIVERIES_DELIVERY_DIALOG_SHOW_OPERATIONS_VALIDITY_WARNING:
            return true
        default:
            return state
    }
}

export const documentSubFolder = (state = null, action) => {
    switch (action.type) {
        case types.DELIVERIES_DOCUMENTS_SET_SELECTED_SUB_FOLDER:
            return action.path
        default:
            return state
    }
}

export const isSavingDelivery = (state = false, action) => {
    switch (action.type) {
        case types.DELIVERIES_ADD_DELIVERY_ATTEMPT:
        case types.DELIVERIES_UPDATE_DELIVERY_ATTEMPT:
            return true
        case types.DELIVERIES_ADD_DELIVERY_SUCCESS:
        case types.DELIVERIES_ADD_DELIVERY_FAILURE:
        case types.DELIVERIES_UPDATE_DELIVERY_SUCCESS:
        case types.DELIVERIES_UPDATE_DELIVERY_FAILURE:
        case types.DELIVERIES_DELIVERY_DIALOG_SHOW_OPERATIONS_VALIDITY_WARNING:
            return false
        default:
            return state
    }
}

export const observing = (state = false, action) => {
    switch (action.type) {
        case types.OBSERVE_DELIVERY:
            return true
        case types.DEOBSERVE_DELIVERY:
            return false
        default:
            return state
    }
}

export default combineReducers({
    deliveries: createPivotTableReducer({
        key: deliveriesPivotTableKey,
        defaultSortColumn: 'createdDate',
        defaultSortDirection: 'asc',
    }),
    items: createPivotTableReducer({
        key: deliveryItemsPivotTableKey,
        defaultSortColumn: 'itemId',
    }),
    documents: createPivotTableReducer({
        key: deliveryDocumentsPivotTableKey,
        defaultSortColumn: 'createdDate',
        defaultSortDirection: 'asc',
    }),
    operations: createPivotTableReducer({
        key: deliveryOperationsPivotTableKey,
        defaultSortColumn: 'itemId',
    }),
    actualTimes: createPivotTableReducer({
        key: deliveryActualTimesPivotTableKey,
        defaultSortColumn: 'start',
    }),
    deliveryTypes,
    workCentreId,
    deliveryStatus,
    userTypes,
    contacts,
    orderTypeId,
    dateTypes,
    timeKey,
    targetStart,
    targetEnd,
    deliveryDepartments,
    deliveryWorkCentres,
    deliveryWorkCentresLoaded,
    calendarData,
    calendarSelectedDate,
    calendarViewRange,
    calendarFieldOrder,
    calendarSelectedFields,
    filters,
    selectedDepartment,
    isLoadingItems,
    deliveryCounts,
    deliveryDialogCurrentTab,
    isShowingOperationsValidityWarning,
    documentSubFolder,
    isSavingDelivery,
    observing,
})
